import React from "react";
import "./index.css";
import { useContextProvider } from "../../context";
import { Language } from "../../types";
import mainImg from "./w3.webp";

const dict = {
  [Language.English]: {
    title: "Car rental</br> in Spain",
    description: "Rent a car for your next trip",
    cta: "Choose car",
  },
  [Language.Spanish]: {
    title: "Alquiler de autos</br> en España",
    description: "Alquile un auto para su próxima aventura",
    cta: "Elegir auto",
  },
  [Language.Russian]: {
    title: "Аренда автомобилей</br> в Испании",
    description: "Арендуйте автомобиль для вашего следующего путешествия",
    cta: "Выбрать авто",
  },
  [Language.Ukrainian]: {
    title: "Аренда автомобілів</br> в Іспанії",
    description: "Орендуйте автомобіль для вашої наступної подорожі",
    cta: "Вибрати авто",
  },
};

export const Welcome: React.FC = () => {
  const { language } = useContextProvider();

  const { title, description, cta } = dict[language];

  const ctaClickHandler = () => {
    const carList = document.querySelector(".CarList");
    if (carList) {
      const y = carList.getBoundingClientRect().top + window.scrollY - 58;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section className="Welcome">
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      <img src={mainImg} alt="You sitting in a car" fetchPriority="high" />
      <h2>{description}</h2>
      <button onClick={ctaClickHandler} aria-label={cta} title={cta}>
        {cta}
      </button>
    </section>
  );
};
